import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { onTeamsResume } from './teams-lifecycle.js';

/**
 * A tab Teams kept suspended may have been away for up to half an hour, and nothing refetched while
 * it was hidden. On resume every query is marked stale, so whatever is on screen refetches the way a
 * reload would, without throwing away the page the user left.
 */
export function useTeamsResumeRefresh(enabled: boolean): void {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled) return;
    return onTeamsResume(() => queryClient.invalidateQueries());
  }, [enabled, queryClient]);
}
